import { Keyboard } from "@fg/icons";
import { Dialog } from "@/components/ui/dialog";

const GROUPS: Array<{ title: string; rows: Array<[string, string]> }> = [
    {
        title: "General",
        rows: [
            ["?", "Show keyboard shortcuts"],
            ["/", "Search Drive"],
            ["N", "New folder"],
            ["Esc", "Clear selection / close"]
        ]
    },
    {
        title: "Files and folders",
        rows: [
            ["↑ ↓ ← →", "Move between items"],
            ["Shift + ↑ ↓", "Extend selection"],
            ["Ctrl / ⌘ + A", "Select all"],
            ["Enter", "Open"],
            ["Space", "Preview"],
            ["F2", "Rename"],
            ["Delete", "Move to bin"],
            ["Shift + F10", "Open the actions menu"]
        ]
    },
    {
        title: "Mouse",
        rows: [
            ["Click", "Select"],
            ["Ctrl / ⌘ + click", "Add to selection"],
            ["Shift + click", "Select a range"],
            ["Double-click", "Open"],
            ["Right-click", "Actions menu"]
        ]
    },
    {
        title: "Preview",
        rows: [
            ["← →", "Previous / next file"],
            ["Esc", "Close preview"]
        ]
    }
];

export function ShortcutsDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
    return (
        <Dialog open={open} onClose={onClose} title="Keyboard shortcuts" icon={<Keyboard className="h-5 w-5 text-primary" />} size="lg">
            <div className="grid gap-x-8 gap-y-5 pb-3 sm:grid-cols-2">
                {GROUPS.map((g) => (
                    <section key={g.title}>
                        <h3 className="mb-2 text-xs font-semibold uppercase tracking-wide text-muted-foreground">{g.title}</h3>
                        <dl className="space-y-1.5 text-sm">
                            {g.rows.map(([keys, desc]) => (
                                <div key={desc + keys} className="flex items-center justify-between gap-3">
                                    <dt>{desc}</dt>
                                    <dd>
                                        <kbd className="whitespace-nowrap rounded-md border bg-muted px-1.5 py-0.5 font-mono text-[11px] text-muted-foreground">{keys}</kbd>
                                    </dd>
                                </div>
                            ))}
                        </dl>
                    </section>
                ))}
            </div>
            <p className="pb-2 text-xs text-muted-foreground">Shortcuts pause while you're typing in a text field.</p>
        </Dialog>
    );
}
